module.exports = __webpack_public_path__ + "img/9788954438285.c8554c17.jpg";